import { render } from "./HistoryParams.vue?vue&type=template&id=5648e22e&scoped=true"
import script from "./HistoryParams.vue?vue&type=script&lang=js"
export * from "./HistoryParams.vue?vue&type=script&lang=js"

import "./HistoryParams.vue?vue&type=style&index=0&id=5648e22e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5648e22e"]])

export default __exports__